import React, { useContext } from 'react';

import * as S from './styles';
import {
  INewStudentProvider,
  NewStudentProviderContext,
} from '../../../ProviderNewStudent';

export default function LoginAs() {
  const { student } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;

  const name = student?.dataStudent?.name ?? '';

  return (
    <S.Container>
      <S.Section className="aviso" role="status" aria-live="polite">
        <S.Inner>
          <S.TextDesktop>Acessado como: </S.TextDesktop>
          <S.TextMobile>Acessado como</S.TextMobile>
          <S.Name>{name}</S.Name>
        </S.Inner>
      </S.Section>
    </S.Container>
  );
}
